import { render } from "./SelectOtherVariant.vue?vue&type=template&id=05025c55&scoped=true"
import script from "./SelectOtherVariant.vue?vue&type=script&lang=js"
export * from "./SelectOtherVariant.vue?vue&type=script&lang=js"

import "../style.scss?vue&type=style&index=0&id=05025c55&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05025c55"]])

export default __exports__